import { Component } from "react";
import { logClientError } from "./firebase";

// Root-level safety net. Without this, any uncaught render-time error unmounts the
// entire React tree and leaves a blank white page until the user manually reloads
// (reported: mobile web, blank page after "save lesson & add to flashcards"). Falls
// back to plain inline styles rather than the app's own CSS classes, since GLOBAL_CSS
// is injected by App.js itself and disappears along with everything else once App has
// crashed.
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught render error:", error, info);
    logClientError({
      message: error?.message || String(error),
      stack: error?.stack,
      componentStack: info?.componentStack,
      source: "react-error-boundary",
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: "100vh", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", textAlign: "center",
        padding: 24, fontFamily: "sans-serif", color: "#3E2723", background: "#FFF8F0",
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>😕</div>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ fontSize: 14, opacity: 0.75, marginBottom: 20, maxWidth: 320 }}>
          Speafy hit an unexpected error. Reloading usually fixes it, and your progress is saved.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 24px", borderRadius: 8, border: "none",
            background: "#D2691E", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer",
          }}
        >
          Reload
        </button>
      </div>
    );
  }
}
